import { boardStateSlice } from './reducer';

export const { patchMatrix, updateMatrix, createMatrix, dragOver, dragStart } =
  boardStateSlice.actions;
